export const stylesx = {
  box: {
    padding: "100px",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    height: "100vh",
  },
};
